import { render, staticRenderFns } from "./ShowClientPortfolio.vue?vue&type=template&id=345aa38a"
import script from "./ShowClientPortfolio.vue?vue&type=script&lang=js"
export * from "./ShowClientPortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports